export const AvatarSize = {
  Width: '32px',
  Height: '32px',
}
